/* ============================================================
   The saving pill on the recommended-products cards.
   ------------------------------------------------------------
   The collection grid writes "Save 30%" beside the struck price;
   Horizon's card has no such part and no percentage to render
   one from, so it is worked out here from the two prices already
   on the card.

   The numbers are read off the rendered money strings rather than
   fetched: the cards arrive from Shopify's recommendations
   endpoint already formatted, and three extra round trips to
   learn a figure that is sitting in the DOM is a poor trade. If a
   string cannot be read the pill is simply not drawn.

   Loaded from snippets/stylesheets.liquid.
   ============================================================ */
(function () {
  'use strict';

  var LABEL = 'Save';

  /* Money as written, to a number. The last group of digits is the amount;
     a separator followed by exactly two digits is the decimal point, which
     covers "€42,00" and "$1,234.56" alike, and a currency written without
     decimals falls through with its separators simply dropped. */
  function amount(el) {
    if (!el) return null;
    var clone = el.cloneNode(true);
    var hidden = clone.querySelectorAll('.visually-hidden');
    for (var i = 0; i < hidden.length; i++) hidden[i].remove();
    var groups = clone.textContent.replace(/\s/g, '').match(/[\d.,]+/g);
    if (!groups) return null;
    var s = groups[groups.length - 1];
    var dec = s.match(/[.,](\d{2})$/);
    s = dec ? s.slice(0, -3).replace(/[.,]/g, '') + '.' + dec[1] : s.replace(/[.,]/g, '');
    var n = parseFloat(s);
    return isFinite(n) ? n : null;
  }

  function paintCard(card) {
    if (card.querySelector('.sc-rec__save')) return;
    var row = card.querySelector('product-price > div');
    if (!row) return;
    var was = row.querySelector('.compare-at-price');
    var now = row.querySelector('.price-item__group.price');
    if (!was || !now) return;

    var a = amount(was);
    var b = amount(now);
    if (a === null || b === null || a <= 0 || b >= a) return;

    var pill = document.createElement('span');
    pill.className = 'sc-rec__save';
    pill.textContent = LABEL + ' ' + Math.round((a - b) / a * 100) + '%';
    was.insertAdjacentElement('afterend', pill);
  }

  /* The cards are fetched after the page, and swapped in wholesale, so the
     work has to be repeatable. Painting is idempotent - a card that already
     carries a pill is skipped - so a second pass over the same cards changes
     nothing and the observer settles instead of looping. */
  function paint(root) {
    var cards = root.querySelectorAll('product-card');
    for (var i = 0; i < cards.length; i++) paintCard(cards[i]);
  }

  /* ------------------------------------------------------------------
     Quick add, sent to the product page instead of an empty dialog.

     Horizon's quick-add fetches the product page and lifts its own product
     block out of it to put inside the modal. This theme replaced that block
     with a custom section, so the fetch returns 200 and the extraction finds
     nothing: the dialog opened at full size with no content in it, and no
     error anywhere, because as far as Horizon is concerned it worked.

     The section is declared in templates/product.json, which Shopify's API
     refuses writes to, so the button cannot simply be switched off in the
     section's own settings. It is intercepted here instead and the visitor
     is taken to the product page, where the real size picker lives.

     Bound in the capture phase so it runs before the component's own
     handler, and stops the event there - otherwise the empty dialog still
     opens behind the navigation. */
  function interceptQuickAdd(host) {
    host.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest && e.target.closest('.quick-add__button');
      if (!btn) return;

      var card = btn.closest('product-card') || btn.closest('[class*="card"]');
      var link = card && card.querySelector('a[href*="/products/"]');
      if (!link || !link.href) return;   // nothing to navigate to: leave it alone

      e.preventDefault();
      e.stopPropagation();
      window.location.href = link.href;
    }, true);
  }

  function watch(host) {
    if (host.dataset.scRecs) return;
    host.dataset.scRecs = '1';
    paint(host);
    interceptQuickAdd(host);
    var obs = new MutationObserver(function () {
      obs.disconnect();
      paint(host);
      obs.observe(host, { childList: true, subtree: true });
    });
    obs.observe(host, { childList: true, subtree: true });
  }

  function start() {
    var hosts = document.querySelectorAll('product-recommendations');
    for (var i = 0; i < hosts.length; i++) watch(hosts[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  /* The theme editor rebuilds a section in place rather than reloading. */
  document.addEventListener('shopify:section:load', start);
})();
